import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.4",
  d: "M7.9987 14.6666C4.3187 14.6666 1.33203 11.6799 1.33203 7.99992C1.33203 4.31992 4.3187 1.33325 7.9987 1.33325C11.6787 1.33325 14.6654 4.31992 14.6654 7.99992C14.6654 11.6799 11.6787 14.6666 7.9987 14.6666Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.15885 11.1666C6.41219 11.1666 4.99219 9.74659 4.99219 7.99992C4.99219 6.25325 6.41219 4.83325 8.15885 4.83325C8.92552 4.83325 9.67219 5.11325 10.2455 5.62659C10.4522 5.80659 10.4722 6.12659 10.2922 6.33325C10.1055 6.53992 9.7922 6.55992 9.58553 6.37992C9.1922 6.03326 8.68552 5.83993 8.15885 5.83993C6.96552 5.83993 5.99219 6.81326 5.99219 8.00659C5.99219 9.19993 6.96552 10.1733 8.15885 10.1733C8.67885 10.1733 9.1922 9.97993 9.58553 9.63326C9.7922 9.45326 10.1122 9.47327 10.2922 9.67993C10.4722 9.8866 10.4522 10.2066 10.2455 10.3866C9.66552 10.8866 8.92552 11.1666 8.15885 11.1666Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
}

})